import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const BackIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <g clip-path="url(#clip0_18479_14424)">
                <path
                    d="M0.666748 2.66699V6.66699H4.66675"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.34008 9.99964C2.77234 11.2266 3.59164 12.2798 4.67452 13.0006C5.7574 13.7214 7.0452 14.0707 8.34389 13.996C9.64258 13.9212 10.8818 13.4264 11.8748 12.5861C12.8679 11.7459 13.5609 10.6056 13.8496 9.33722C14.1382 8.06881 14.0068 6.74094 13.4752 5.55371C12.9435 4.36647 12.0404 3.38417 10.902 2.75482C9.76351 2.12546 8.45135 1.88315 7.1632 2.06438C5.87505 2.24562 4.68069 2.84059 3.76008 3.75964L0.666748 6.66631"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_18479_14424">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
